/**
 * Options for onset checkbox in Visual Field Test.
 */
export enum ONSET_TYPE {
    INSTANT = 'Instant',
    LINEAR = 'Linear',
    LIGARITHMIC = 'Logarithmic',
}
